<template>
  <distributionView is-verify />
</template>
<script>
import distributionView from '@/views/center-business/stock/distribution/plan/view';
export default {
  name: 'BusinessStockVerifyPlanView',
  components: {
    distributionView,
  },
  mixins: [],
  data() {
    return {};
  },
  computed: {},
  watch: {},
  mounted() {},
  methods: {},
};
</script>
<style lang="scss" scoped></style>
